import type { BrightnessCorrectionState, GammaBrightnessCorrectionState } from '@ikegps/core-api';
import type { CollectionModelBrightnessCorrection } from '../brightnessCorrection/brightnessCorrection';
import { CollectionModelGammaBrightnessCorrection } from '../brightnessCorrection/gamma.brightnessCorrection';

function writeGammaBrightnessCorrection(
	brightnessCorrection: CollectionModelGammaBrightnessCorrection
): GammaBrightnessCorrectionState {
	const state = brightnessCorrection.state;

	const exponent = state.exponent;

	return {
		id: state.id,
		tag: 'gamma',
		exponent,
	};
}

export class BrightnessCorrectionWriter {
	static write(brightnessCorrection: CollectionModelBrightnessCorrection): BrightnessCorrectionState {
		if (CollectionModelGammaBrightnessCorrection.isGamma(brightnessCorrection)) {
			return writeGammaBrightnessCorrection(brightnessCorrection);
		}

		throw new Error(`Unexpected drawable: ${brightnessCorrection.id}:${brightnessCorrection.state.tag}`);
	}
}
